import React from "react";
import { Backdrop, Box } from "@mui/material";
import appLogo from "../../assets/images/app-logo/app_logo_white.png";

const CustomSpinner: React.FC = () => {
  return (
    <Backdrop
      open={true}
      style={{
        zIndex: 9999,
        margin: 0,
      }}
    >
      <Box>
        <img src={appLogo} alt="AppLogo" width="120px" height="70px" />
      </Box>
    </Backdrop>
  );
};

export default CustomSpinner;
